<template>
    <v-card outlined elevation="0" tile>
        <v-data-table
            :headers="headers"
            :items="list"
            :items-per-page="-1"
            :loading="fetching"
            :expanded.sync="expanded"
            hide-default-footer
            disable-pagination
            disable-filtering
            show-expand
            item-key="juego"
            >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.juego="{ item }">
                <v-chip label small>
                    {{ item.juego }}
                </v-chip>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.venta="{ item }">
                <Venta :reporte="item"/>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.comision="{ item }">
                <Comision :reporte="item"/>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.premio="{ item }">
                <Premio :reporte="item"/>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.total="{ item }">
                <Total :reporte="item"/>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:expanded-item="{ item }">
                <td :colspan="headers.length + 1" class="pa-4">
                    <Sorteo :params="{ ... params, juego_id: item.juego_id }"/>
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import Sorteo from './sorteo.vue';

import ReporteService from '@/services/institution/ReporteService';

import Venta from '@/components/entities/reporte/components/venta.vue';
import Comision from '@/components/entities/reporte/components/comision.vue';
import Premio from '@/components/entities/reporte/components/premio.vue';
import Total from '@/components/entities/reporte/components/total.vue';

export default {
    components: {
        Sorteo,
        Venta,
        Comision,
        Premio,
        Total,
    },
    props: {
        params: {
            defaults: function() {
                return {};
            },
        },
    },
    data: function () {
        return {
            list: [],
            fetching: false,
            expanded: [],
        };
    },
    computed: {
        headers: function () {
            return [
                { text: 'Juego', align: 'start', value: 'juego' },
                { text: 'Ventas', value: 'venta' },
                { text: 'Comisión', value: 'comision' },
                { text: 'Premios', value: 'premio' },
                { text: 'Total', value: 'total'},
            ];
        },
    },
    methods: {
        fetch: async function () {
            this.fetching = true;
            this.list = [];
            this.expanded = [];

            try {
                const {
                    list
                } = await ReporteService.VentaPorJuego(this.params);

                this.list = list;
            } catch (error) {
                // ERROR
            }

            this.fetching = false;
        },
    },
    watch: {
        params: function () {
            this.fetch();
        },
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    }
}
</script>